import './HomePageNavCards.scss';
import NavCard from './NavCard';
import { 
    faCommentsDollar, 
    faFileInvoice, 
    faMoneyBillTransfer,
    faMoneyCheckDollar, 
} from '@fortawesome/pro-light-svg-icons';
import { useNavigation } from 'hooks';

export default function HomePageNavCards() {
    const { deductionsUrl, disputesUrl, invoicesUrl, paymentsUrl } = useNavigation();

    return(
        <>
            <div className="home-page-nav-cards">
                <NavCard 
                    cardIcon={faMoneyCheckDollar}
                    cardTitle="Payments"
                    cardText="View payments and related adjustments. This includes payment status, customer and Dot deductions from the payment, and the ability to create disputes."
                    cardLinkUrl={paymentsUrl}
                    cardLinkText="PAYMENTS"
                />
                <NavCard 
                    cardIcon={faFileInvoice}
                    cardTitle="Invoices"
                    cardText="View invoices and related adjustments. This includes invoice item details, Dot deductions for pricing and quantity, and the ability to create disputes."
                    cardLinkUrl={invoicesUrl}
                    cardLinkText="INVOICES"
                />
                <NavCard 
                    cardIcon={faMoneyBillTransfer}
                    cardTitle="Deductions"
                    cardText="View deduction information by date. This includes all deductions from payments made within a selected date range and the ability to create disputes."
                    cardLinkUrl={deductionsUrl}
                    cardLinkText="DEDUCTIONS"
                />
                <NavCard 
                    cardIcon={faCommentsDollar}
                    cardTitle="Disputes"
                    cardText="View dispute information.  This includes the status of disputes, dispute finalization decisions, and disputes routed back to the supplier."
                    cardLinkUrl={disputesUrl}
                    cardLinkText="DISPUTES"
                />
            </div>
        </>
    );
}